import { SuspenseWithFallback } from 'lazy-routes';
import { useParams } from 'react-router';
import { Offset } from 'turnip/Offset/Offset';
import { SimpleNavBar } from 'turnip/SimpleNavBar/SimpleNavBar';
import { dashboardAccountUrl } from 'utils/carrotUrls';

/**
 * Chrome for the account-based Call Tracking route
 * (`/account/:accountId/call-tracking/*`). Account-manager serves Call
 * Tracking itself, so members reach this route through saved copies of older
 * account-manager links, such as bookmarks. Renders a simplified nav bar whose
 * "Back to account" link returns to that account in account-manager.
 */
export function CallTrackingLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const params = useParams();
  // NOTE: This layout is only rendered when the route has and account ID
  const accountId = params.accountId!;

  return (
    <>
      <SimpleNavBar backUrl={dashboardAccountUrl(accountId)} />

      <Offset top={24}>
        <SuspenseWithFallback title="Loading page">
          {children}
        </SuspenseWithFallback>
      </Offset>
    </>
  );
}
